import { Icon } from '@iconify/react'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import InfiniteScroll from 'react-infinite-scroll-component'

// Ant Design
import { Avatar, Timeline, Typography, Space } from 'antd'

// slices
import {
    changeHistoryPage,
    historyTaskGet,
    mainHistoryTaskGet,
    refreshTaskHistory,
    tasksState,
} from './tasks.slice'

// helpers
import dayjs from 'dayjs'
import { getInitials } from '../../utils/commonUtils'

const getHistoryCreatorName = (createdBy) => {
    if (!createdBy) return ''
    if (Array.isArray(createdBy)) {
        return createdBy[0]?.name ?? ''
    }
    return createdBy?.name ?? ''
}

function ActivitySectionTimeline({
    taskId: taskIdProp,
    isActive = true,
    taskListKind = 'support',
}) {
    const isMainTask = taskListKind === 'main'
    const dispatch = useDispatch()
    const { Text } = Typography

    const {
        pageLimitHistory,
        skipPageHistory,
        currentPageHistory,
        historyTask,
        isNextHistory,
        selectedTask,
        historyStatus,
        selectedSubTask,
        formSubTask,
    } = useSelector(tasksState)

    const [filteredHistoryTask, setFilteredHistoryTask] = useState([])

    const resolvedTaskId =
        taskIdProp ??
        (selectedSubTask && formSubTask
            ? selectedSubTask?.data?._id
            : selectedTask?.data?._id)

    useEffect(() => {
        if (!isActive || !resolvedTaskId) return

        setFilteredHistoryTask([])
        dispatch(refreshTaskHistory(resolvedTaskId, taskListKind))
    }, [dispatch, isActive, resolvedTaskId, taskListKind])

    useEffect(() => {
        if (!Array.isArray(historyTask)) return

        if (skipPageHistory === 0) {
            setFilteredHistoryTask(historyTask)
            return
        }

        if (historyTask.length > 0) {
            setFilteredHistoryTask((prev) => [...prev, ...historyTask])
        }
    }, [historyTask, skipPageHistory])

    async function fetchMoreHistory() {
        if (isNextHistory && resolvedTaskId) {
            const fetchHistory = isMainTask
                ? mainHistoryTaskGet
                : historyTaskGet
            await dispatch(fetchHistory(resolvedTaskId))
            dispatch(
                changeHistoryPage({
                    currentPage: currentPageHistory + 1,
                    skip: skipPageHistory + pageLimitHistory,
                    pageLimit: pageLimitHistory,
                })
            )
        }
    }

    if (historyStatus === 'loading') {
        return (
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: '30px 20px',
                }}
            >
                <Icon
                    icon="line-md:loading-loop"
                    style={{ fontSize: 36, color: '#6366f1' }}
                />
            </div>
        )
    }

    return (
        <>
            {filteredHistoryTask?.length === 0 ? (
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        padding: '30px 20px',
                    }}
                >
                    <Icon
                        icon="mdi:history"
                        width={50}
                        height={50}
                        style={{
                            color: '#cbd5e1',
                            opacity: 0.6,
                            marginBottom: '6px',
                        }}
                    />
                    <Text
                        style={{
                            fontSize: '14px',
                            color: '#64748b',
                            fontWeight: 500,
                            margin: 0,
                        }}
                    >
                        No activity found
                    </Text>
                </div>
            ) : (
                <div
                    style={{
                        width: '100%',
                        maxHeight: '60vh',
                        overflowY: 'auto',
                        padding: '15px',
                        // border: '1px solid #f0f0f0',
                        borderRadius: 6,
                        // backgroundColor: '#fafafa',
                    }}
                >
                    <InfiniteScroll
                        dataLength={filteredHistoryTask.length}
                        next={fetchMoreHistory}
                        hasMore={isNextHistory}
                        style={{ overflow: 'inherit' }}
                    >
                        <Timeline mode="left">
                            {[...filteredHistoryTask]
                                .sort(
                                    (a, b) =>
                                        new Date(b.time) - new Date(a.time)
                                )
                                .map((task) => {
                                    const creatorName = getHistoryCreatorName(
                                        task?.createdBy
                                    )
                                    return (
                                    <Timeline.Item
                                        key={task._id}
                                        dot={
                                            <Avatar
                                                size={32}
                                                style={{
                                                    backgroundColor: '#4f46e5',
                                                    fontSize: 14,
                                                }}
                                            >
                                                {getInitials(creatorName) ||
                                                    'U'}
                                            </Avatar>
                                        }
                                    >
                                        <Space direction="vertical" size={2}>
                                            <Text strong>
                                                {creatorName}
                                            </Text>
                                            <div
                                                dangerouslySetInnerHTML={{
                                                    __html: task?.description,
                                                }}
                                                style={{
                                                    color: '#595959',
                                                    fontSize: 13,
                                                }}
                                            />
                                            <Text
                                                type="secondary"
                                                style={{ fontSize: 12 }}
                                            >
                                                {dayjs(task?.time).format(
                                                    'DD MMM YYYY, hh:mm A'
                                                )}
                                            </Text>
                                        </Space>
                                    </Timeline.Item>
                                    )
                                })}
                        </Timeline>
                    </InfiniteScroll>
                </div>
            )}
        </>
    )
}

export default ActivitySectionTimeline
